import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { BookIcon } from "../../../assets/icons/dashboard";

const NoAppointments = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box>
        <img src={BookIcon} alt="calendar-icon" />
        <Typography variant="h2">Não temos treinamentos para você no momento</Typography>
      </Box>
    </Box>
  );
}

export default NoAppointments;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: theme.spacing(0, 6),
      minHeight: '60vh',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      '& h2': {
        marginTop: theme.spacing(2),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      }
    },
  }))